// Vue de rue Google (API Street View Static) pour « Voir la maison ». Chargée à la demande, jamais conservée.

export function streetViewUrl(apiKey: string, position: { lat: number; lng: number }): string {
  const params = new URLSearchParams({
    size: '640x360',
    location: `${position.lat.toFixed(6)},${position.lng.toFixed(6)}`,
    fov: '80',
    source: 'outdoor',
    // 404 au lieu d'une image grise quand aucune vue n'existe : l'échec est affiché comme tel.
    return_error_code: 'true',
    key: apiKey,
  })
  return `https://maps.googleapis.com/maps/api/streetview?${params.toString()}`
}
